import fp from 'lodash/fp'
import mapper from 'utils/simple-mapper'

const mapping = [
  ['beneficiaryName'],
  ['email'],
  ['jurisdiction'],
  ['categories', 'category', fp.map('id')],
  ['subCategories', 'subCategory', fp.map('id')],
  ['password'],
  ['website'],
  ['logo'],
  ['active'],
  ['id'],
  ['marketingPromotion'],
]

export const toBeneficiaryModel = (form) => mapper(form, mapping)
